import * as React from 'react';
import Form from 'react-bootstrap/Form';
import LookupValueSelectList from '../LookupValueSelectList/LookupValueSelectList';
import { LookupValueTypes } from '../LookupValueSelectList/lookupValueTypes';
import { IWorkflowCondition } from './business-objects/common';
import { Button } from 'react-bootstrap';

interface IWorkflowConditionProps {
  condition: IWorkflowCondition;
  idx: number;
  handleConditionChange: (
    e: React.FormEvent,
    condition: IWorkflowCondition,
    dataField: string
  ) => void;
  removeTriggerCondition: (id: number) => void;
}
interface IWorkflowLocalState {
  selectedConditionType?: string;
}
export default class WorkflowCondition extends React.Component<
  IWorkflowConditionProps,
  IWorkflowLocalState
> {
  renderConditionValues(typeId: string) {
    switch (typeId) {
      case '-1':
        return (
          <Form.Group controlId='Status'>
            <Form.Label>
              <strong>Equals</strong>
            </Form.Label>
            <LookupValueSelectList
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
              value={this.props.condition.conditionValue || '2'}
              type={LookupValueTypes.BYNAME}
              typeName='WorkflowItemStatus'
              includeAll={false}
            />
          </Form.Group>
        );
      case '-2':
        return (
          <Form.Group>
            <Form.Check
              inline
              label='Has Fatalities '
              name={this.props.condition.id.toString()}
              type='radio'
              value='yes'
              checked={this.props.condition.conditionValue == 'yes'}
              id={`rdoYes${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
            <Form.Check
              inline
              label='No Fatalities'
              name={this.props.condition.id.toString()}
              type='radio'
              value='no'
              checked={this.props.condition.conditionValue == 'no'}
              id={`rdoNo${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
          </Form.Group>
        );
      case '-3':
        return (
          <Form.Group>
            <Form.Check
              inline
              label='Has State Property Damage '
              name={this.props.condition.id.toString()}
              type='radio'
              value='yes'
              checked={this.props.condition.conditionValue == 'yes'}
              id={`rdoYes${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
            <Form.Check
              inline
              label='No Damage'
              name={this.props.condition.id.toString()}
              type='radio'
              value='no'
              checked={this.props.condition.conditionValue == 'no'}
              id={`rdoNo${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
          </Form.Group>
        );
      case '-4':
        return (
          <Form.Group>
            <Form.Check
              inline
              label='No Match '
              name={this.props.condition.id.toString()}
              type='radio'
              value='no'
              checked={this.props.condition.conditionValue == 'no'}
              id={`rdoMatchNo${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
            <Form.Check
              inline
              label='Partial Match'
              name={this.props.condition.id.toString()}
              type='radio'
              value='partial'
              checked={this.props.condition.conditionValue == 'partial'}
              id={`rdoPartial${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
            <Form.Check
              inline
              label='Exact Match'
              name={this.props.condition.id.toString()}
              type='radio'
              value='exact'
              checked={this.props.condition.conditionValue == 'exact'}
              id={`rdoExact${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
          </Form.Group>
        );
      case '-5':
        return (
          <Form.Group>
            <Form.Check
              inline
              label='Report Is Valid '
              name={this.props.condition.id.toString()}
              type='radio'
              value='yes'
              checked={this.props.condition.conditionValue == 'yes'}
              id={`rdoYes${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
            <br />
            <Form.Check
              inline
              label='Not Valid'
              name={this.props.condition.id.toString()}
              type='radio'
              value='no'
              checked={this.props.condition.conditionValue == 'no'}
              id={`rdoNo${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
          </Form.Group>
        );
        case '-6':
        return (
          <Form.Group>
            <Form.Check
              inline
              label='No '
              name={this.props.condition.id.toString()}
              type='radio'
              value='no'
              checked={this.props.condition.conditionValue == 'no'}
              id={`rdoMatchNo${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
            <Form.Check
              inline
              label='Yes'
              name={this.props.condition.id.toString()}
              type='radio'
              value='yes'
              checked={this.props.condition.conditionValue == 'yes'}
              id={`rdoPartial${this.props.condition.id.toString()}`}
              onChange={(e) =>
                this.props.handleConditionChange(
                  e,
                  this.props.condition,
                  'value'
                )
              }
            />
          </Form.Group>
        );
      default:
        return 'Not Configured';
    }
  }
  public render() {
    return (
      <React.Fragment>
        {this.props.idx > 0 ? 'AND' : <hr />}
        <i
          title='Remove Condition'
          className='fas fa-ban pointer float-right'
          onClick={(e) =>
            this.props.removeTriggerCondition(this.props.condition.id)
          }
        ></i>
        <Form.Group controlId='Name'>
          <Form.Label>
            <strong>When</strong>
          </Form.Label>
          <LookupValueSelectList
            onChange={(e) =>
              this.props.handleConditionChange(e, this.props.condition, 'type')
            }
            value={this.props.condition.workflowConditionTypeId.toString()}
            type={LookupValueTypes.BYNAME}
            typeName='WorkflowConditionType'
            includeAll={false}
          />
        </Form.Group>
        {this.renderConditionValues(
          this.props.condition.workflowConditionTypeId.toString()
        )}
      </React.Fragment>
    );
  }
}
